/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeslotDisplayDateComponents } from './TimeslotDisplayDateComponents';
import {
    TimeslotDisplayDateComponentsFromJSON,
    TimeslotDisplayDateComponentsFromJSONTyped,
    TimeslotDisplayDateComponentsToJSON,
} from './TimeslotDisplayDateComponents';

/**
 * 
 * @export
 * @interface TimeslotDisplay
 */
export interface TimeslotDisplay {
    /**
     * Reservation duration appropriate for user display, e.g. "30 minutes"
     * @type {string}
     * @memberof TimeslotDisplay
     */
    duration: string;
    /**
     * Local reservation end time appropriate for grid display, in 24 hour format e.g. "8:00" or "13:00"
     * @type {string}
     * @memberof TimeslotDisplay
     */
    isoEndTime: string;
    /**
     * Local reservation start time appropriate for grid display, in 24 hour format e.g. "8:00" or "13:00"
     * @type {string}
     * @memberof TimeslotDisplay
     */
    isoStartTime: string;
    /**
     * Local reservation start time appropriate for user display, e.g. "8:00 AM"
     * @type {string}
     * @memberof TimeslotDisplay
     */
    localTime: string;
    /**
     * 
     * @type {TimeslotDisplayDateComponents}
     * @memberof TimeslotDisplay
     */
    dateComponents: TimeslotDisplayDateComponents;
    /**
     * Local date string in ISO 8601 format, e.g. "2025-04-16"
     * @type {string}
     * @memberof TimeslotDisplay
     */
    localDate: string;
}

/**
 * Check if a given object implements the TimeslotDisplay interface.
 */
export function instanceOfTimeslotDisplay(value: object): value is TimeslotDisplay {
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('isoEndTime' in value) || value['isoEndTime'] === undefined) return false;
    if (!('isoStartTime' in value) || value['isoStartTime'] === undefined) return false;
    if (!('localTime' in value) || value['localTime'] === undefined) return false;
    if (!('dateComponents' in value) || value['dateComponents'] === undefined) return false;
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    return true;
}

export function TimeslotDisplayFromJSON(json: any): TimeslotDisplay {
    return TimeslotDisplayFromJSONTyped(json, false);
}

export function TimeslotDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotDisplay {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'],
        'isoEndTime': json['isoEndTime'],
        'isoStartTime': json['isoStartTime'],
        'localTime': json['localTime'],
        'dateComponents': TimeslotDisplayDateComponentsFromJSON(json['dateComponents']),
        'localDate': json['localDate'],
    };
}

export function TimeslotDisplayToJSON(value?: TimeslotDisplay | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'duration': value['duration'],
        'isoEndTime': value['isoEndTime'],
        'isoStartTime': value['isoStartTime'],
        'localTime': value['localTime'],
        'dateComponents': TimeslotDisplayDateComponentsToJSON(value['dateComponents']),
        'localDate': value['localDate'],
    };
}

